<template>
<div>
<h1>HERTER</h1>
  <pdf src="../../../static/documents/OoshZonePhilosophy.pdf"></pdf>
</div>
</template>

<script>
// import PDFViewer from './PDFViewer'
import pdf from 'vue-pdf'

export default {
  name: 'Philosophy',
  components: { pdf }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Philosophy.vue